import { FC } from "react";

import Desktop from "../../../../assets/images/content/pillar-1/repair-of-home-appliances/repair-desktop.svg";
import Mobile from "../../../../assets/images/content/pillar-1/repair-of-home-appliances/repair-mobile.svg";

const RepairOfHomeAppliances: FC = () => {
	return (
		<div className="flex flex-col items-center justify-center border-dotted border-t-2 border-gray-500">
			<img className="hidden md:block w-full mt-8" src={Desktop} role="presentation" />
			<img className="block md:hidden max-w-lg mt-8" src={Mobile} role="presentation" />
		</div>
	);
};

export { RepairOfHomeAppliances };